import Http from './http'

const BASE_URL = "/api/unit"

export default {
  async index(opt) {
    return Http.get(`${BASE_URL}/index`, opt)
  },
  async get(id) {
    return Http.get(`${BASE_URL}/get`, {id: id})
  },
  async post(data) {
    return Http.post(`${BASE_URL}/post`, data)
  },
  async del(id) {
    return Http.post(`${BASE_URL}/del`, undefined, {id: id})
  },
  async dict(query) {
    return Http.get(`${BASE_URL}/dict`, query)
  },
  async allForMap() {
    return Http.get(`${BASE_URL}/all-for-map`)
  },
}




// WEBPACK FOOTER //
// ./src/api/unit.js